var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaPptxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_pptx_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139228",
    "data-name": "\\uD328\\uC2A4 139228",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139229",
    "data-name": "\\uD328\\uC2A4 139229",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.987 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139230",
    "data-name": "\\uD328\\uC2A4 139230",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.914.914,0,0,1,.269.269.9.9,0,0,1,.91,0H27.077a.91.91,0,1,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.807 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139231",
    "data-name": "\\uD328\\uC2A4 139231",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.987 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139232",
    "data-name": "\\uD328\\uC2A4 139232",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.987 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139233",
    "data-name": "\\uD328\\uC2A4 139233",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.364)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139234",
    "data-name": "\\uD328\\uC2A4 139234",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#e63950"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139241",
    "data-name": "\\uD328\\uC2A4 139241",
    d: "M0,12.052l19.3,7.466L12.423,0A20.74,20.74,0,0,0,0,12.052Z",
    transform: "translate(22.106 33.58)",
    fill: "#e63950"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139242",
    "data-name": "\\uD328\\uC2A4 139242",
    d: "M20.713,7.466,1.409,0A20.647,20.647,0,0,0,14,27.045Z",
    transform: "translate(20.695 45.631)",
    fill: "#e8566f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139243",
    "data-name": "\\uD328\\uC2A4 139243",
    d: "M6.907,0A20.677,20.677,0,0,0,0,1.179l.026.015L6.907,20.713.191,40.292.166,40.3A20.716,20.716,0,1,0,6.907,0Z",
    transform: "translate(34.502 32.384)",
    fill: "#b7022d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139374",
    "data-name": "\\uD328\\uC2A4 139374",
    d: "M2.274,6.849v3.535H0V0H3.928A4.884,4.884,0,0,1,6.994.823,2.879,2.879,0,0,1,8.041,3.232,3.28,3.28,0,0,1,6.884,5.867a4.505,4.505,0,0,1-3.018.982ZM2.26,1.633V5.2h.606A3.736,3.736,0,0,0,5.13,4.73a1.8,1.8,0,0,0,.555-1.45,1.467,1.467,0,0,0-.534-1.227,3.668,3.668,0,0,0-2.112-.42ZM12.1,6.849v3.535H9.829V0h3.928a4.884,4.884,0,0,1,3.066.823,2.879,2.879,0,0,1,1.047,2.408,3.28,3.28,0,0,1-1.158,2.636,4.505,4.505,0,0,1-3.018.982Zm-.014-5.216V5.2H12.7a3.736,3.736,0,0,0,2.264-.472,1.8,1.8,0,0,0,.555-1.45,1.467,1.467,0,0,0-.534-1.227,3.668,3.668,0,0,0-2.112-.42Zm15.548.09H24.227v8.661H21.953V1.723H18.542V0h9.1Zm10.415,8.661h-2.7l-2.4-3.7-2.453,3.7H28.02l3.666-5.216L28.1,0H30.79l2.343,3.562L35.531,0h2.487L34.4,5.078Z",
    transform: "translate(3.607 9.564)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaPptxIcon);
export default __webpack_public_path__ + "static/media/minerva_pptx_icon.f7c295ca90094abc0195bf0ad959abd9.svg";
export { ForwardRef as ReactComponent };